import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Tabs, TabsList, TabsTrigger, TabsContent } from './ui/tabs';
import MemberMgmtPanel from './MemberMgmtPanel';
import OLMembersPanel from './OLMembersPanel';
import PeopleAccessPanel from './PeopleAccessPanel';
import ChatAdminPanel from './ChatAdminPanel';

/**
 * MembersHub — the "Members" tab.
 *  - CS / Tech Specialist: sub-tabs Website Members | OmniLeagues Members (org scope).
 *  - League Admin (only): a single OmniLeagues Members panel scoped to their league.
 */
export default function MembersHub({ orgId }) {
  const { user } = useAuth();
  const roles = user?.roles || [];
  const isCorporate = roles.some((r) =>
    ['company_support', 'semprion_admin'].includes(r.role_type));
  const tsRole = roles.find((r) => r.role_type === 'tech_specialist' && r.org_id);
  const leagueRole = roles.find((r) => r.role_type === 'league_admin' && r.league_id);

  // Corporate operators (company_support / semprion) manage ONLY corporate OL users here —
  // no Website Members, no org scope. Customer members are managed by each Tech Specialist.
  if (isCorporate) {
    return <OLMembersPanel scope="corporate" />;
  }
  // League Admin (not a TS) → league-scoped staff only.
  if (!tsRole && leagueRole) {
    return <OLMembersPanel scope={`league:${leagueRole.league_id}`} />;
  }

  // Tech Specialist → Website Members + OmniLeagues Members (org scope).
  return (
    <Tabs defaultValue="website" className="space-y-3">
      <TabsList>
        <TabsTrigger value="website" data-testid="members-sub-website">Website logins (old, password)</TabsTrigger>
        <TabsTrigger value="ol" data-testid="members-sub-ol">OmniLeagues Members</TabsTrigger>
        <TabsTrigger value="access" data-testid="members-sub-access">Members (no password)</TabsTrigger>
        <TabsTrigger value="chat" data-testid="members-sub-chat">Chat</TabsTrigger>
      </TabsList>
      <TabsContent value="website">
        <MemberMgmtPanel orgId={orgId} />
      </TabsContent>
      <TabsContent value="ol">
        <OLMembersPanel scope={`org:${orgId}`} />
      </TabsContent>
      <TabsContent value="access">
        <PeopleAccessPanel orgId={orgId} />
      </TabsContent>
      <TabsContent value="chat">
        <ChatAdminPanel orgId={orgId} />
      </TabsContent>
    </Tabs>
  );
}
